export enum DashboardEditDefaultBlock {
  Root = 'DashboardEditDefaults',
}
